export default __webpack_public_path__ + "static/ben-lesh-9e4878a4f5d9f0a910f5d8430ae156b1.jpg";